import { todosKeys, useNodeService } from "@fero/hooks";
import { useMemo } from "react";

interface TodosParams {
  organisationId: string;
  enabled?: boolean;
}

export const useGetTodos = ({
  organisationId,
  enabled = true,
}: TodosParams) => {
  const nodeService = useNodeService();

  const result = nodeService.dashboard.todos.useQuery(
    todosKeys.list(),
    {
      params: { organisationId },
    },
    {
      enabled,
      staleTime: 5 * 60 * 1000, // 5 minutes
      refetchInterval: 5 * 60 * 1000, // 5 minutes
      refetchOnWindowFocus: false,
    },
  );

  const transformedData = useMemo(() => {
    if (result.data?.status === 200) {
      return result.data.body.items;
    }
    return undefined;
  }, [result.data]);

  return {
    ...result,
    data: transformedData,
  };
};
